import React, { createContext, useContext, useState } from "react";

const HasarContext = createContext();

export const HasarProvider = ({ children }) => {
    // Burada global state'leri tan�mlay�n
    const [servisTipi, setServisTipi] = useState(null);
    const [hasarTipi, setHasarTipi] = useState(null);
    const [policeNo, setPoliceNo] = useState(null);
    const [plaka, setPlaka] = useState(null);
    const [token, setToken] = useState(null); // JWT token i�in
    
    // KaskoIhbarYap response bilgileri
    const [ihbarResponse, setIhbarResponse] = useState({
        eksperNot: "",
        eksperTel: "",
        eksperWp: "",
        dosyaEksperKodu: "",
        dosyaEksperi: "",
        dosyaNo: null,
        dosyaSorumlusu: "",
        messages: null
    });

    // �htiyaca g�re ba�ka state'ler eklenebilir

    return (
        <HasarContext.Provider 
            value={{ 
                servisTipi, 
                setServisTipi, 
                hasarTipi, 
                setHasarTipi, 
                policeNo, 
                setPoliceNo, 
                plaka, 
                setPlaka, 
                token, 
                setToken,
                ihbarResponse,
                setIhbarResponse
            }}
        >
            {children}
        </HasarContext.Provider>
    );
};

export const useHasar = () => useContext(HasarContext);
